import { FC, useEffect } from "react";

import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { Spin } from "antd";  // Assuming Ant Design for UI

const AltQuoteLandingPage: FC = () => {
  const { lrId } = useParams<{ lrId: string }>();  // Extract LRId from URL path
  const [ searchParams ] = useSearchParams();
  const navigate = useNavigate();

  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (lrId && sessionId) {
      // Redirect to the AltQuote page with the same parameters
      navigate(`/trustben-altquote/${ lrId }/altquote?session_id=${ sessionId }`, { replace: true });
    } else {
      // Handle missing params (e.g., redirect to error or sign-in)
      navigate('/sign-in');
    }
  }, [ lrId, sessionId, navigate ]);

  // Show a loading spinner while redirecting
  return (
    <div style={ { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' } }>
      <Spin size="large" tip="Redirecting to AltQuote..." />
    </div>
  );
};

export default AltQuoteLandingPage;
